import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function ConfermaBox(props: { children?: JSX.Element | JSX.Element[] }) {
  const { children } = props;
  const theme = useTheme();
  return (
    <Box
      style={{
        borderRadius: "10px",
        border: "1px solid",
        borderColor: theme.palette.divider,
        padding: 8,
      }}
    >
      {children}
    </Box>
  );
}
